awardCalculation.classy.controller({
    name: 'ReportedIncomeController',
    inject: ['$scope', '$http', '$timeout', 'RestService', 'CalculationService', 'ApplicationService', 'EditSumsModelService',
        'ModelService', 'ResetService', 'BinFactory', 'DateService'],
    init: function()
    {
        this.$.ApplicationService = this.ApplicationService;
        this.$.ResetService = this.ResetService;
        this.$.versionNo = versionNo;
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 206;
                var slideoutTabWidth = $(".slideout-tabs").width();
                $(".slideout-tabs .nav-tabs").css("width", slideoutTabWidth + 'px');
            }).trigger('resize');
            var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
            $(".data-start").css("margin-top", slideoutTabHeight + 'px');
        }, 300);
        this.$.incomelabel = this.ApplicationService.getIncomeLabel();
    },
    reportedIncomePut: function(scope, instance, form)
    {
        var putData = {};
        var data =  this.ApplicationService.getFamilyData().edit_sums;
        putData.Inc_Annual_1 = data.Inc_Annual_1;
        putData.Inc_Annual_2 = data.Inc_Annual_2;
        putData.Inc_Annual = data.Inc_Annual_1 + data.Inc_Annual_2;
        putData.Inc_Business = data.Inc_Business;
        putData.Inc_Div_Int = data.Inc_Div_Int;
        putData.Inc_Cap_Gain = data.Inc_Cap_Gain;
        putData.Inc_Estate = data.Inc_Estate;
        putData.Inc_Trust = data.Inc_Trust;
        putData.Inc_Child_Supp = data.Inc_Child_Supp;
        putData.Inc_Alimony = data.Inc_Alimony;
        putData.Inc_Gifts = data.Inc_Gifts;
        putData.Inc_Other = data.Inc_Other;
        putData.Exp_Child_Supp = data.Exp_Child_Supp;
        putData.Exp_Alimony = data.Exp_Alimony;
        return this.ModelService.EditSumsService.putHelper(data, putData, this.CalculationService.reCalc);
    },
    startSaveProcess: function(scope, instance, form)
    {
        instance.options.factor  = .3;
        var self = this;

        var putData = {};
        var data =  this.ApplicationService.getFamilyData().edit_sums;
        putData.Inc_Annual_1 = data.Inc_Annual_1;
        putData.Inc_Annual_2 = data.Inc_Annual_2;
        putData.Inc_Annual = data.Inc_Annual_1 + data.Inc_Annual_2;
        putData.Inc_Business = data.Inc_Business;
        putData.Inc_Div_Int = data.Inc_Div_Int;
        putData.Inc_Cap_Gain = data.Inc_Cap_Gain;
        putData.Inc_Estate = data.Inc_Estate;
        putData.Inc_Trust = data.Inc_Trust;
        putData.Inc_Child_Supp = data.Inc_Child_Supp;
        putData.Inc_Alimony = data.Inc_Alimony;
        putData.Inc_Gifts = data.Inc_Gifts;
        putData.Inc_Other = data.Inc_Other;
        putData.Exp_Child_Supp = data.Exp_Child_Supp;
        putData.Exp_Alimony = data.Exp_Alimony;
        angular.forEach(putData, function(value, key) {
            if (putData[key]=='')
                putData[key]=0;
        })

        this.ApplicationService.getFamilyData().awardData.reportedIncome = parseInt(putData.Inc_Annual_1) + parseInt(putData.Inc_Annual_2) + parseInt(putData.Inc_Business) + parseInt(putData.Inc_Div_Int) + parseInt(putData.Inc_Cap_Gain) + parseInt(putData.Inc_Estate) + parseInt(putData.Inc_Trust) + parseInt(putData.Inc_Child_Supp) + parseInt(putData.Inc_Alimony) + parseInt(putData.Inc_Gifts) + parseInt(putData.Inc_Other) - parseInt(putData.Exp_Child_Supp) - parseInt(putData.Exp_Alimony);

        this.$http.put("/api/family/" + data.familyID + '/editsums/' + data.applicationID, data).success(function(data, status, headers, config) {
            self.EditSumsModelService.resolveData(self.ApplicationService.getFamilyNo());
            self.CalculationService.reCalc();
            instance.options.callMe(data, status, headers, config, instance);
        });
    },
    successSave: function(scope, instance, callback) 
    {
        instance.stop(1);
        if (typeof callback !== 'undefined')
            callback();  
    }
});

stateProviders.push({
    name: 'schoolside.application.awardCalculation.reportedIncome',
    url: '/reportedIncome',
    templateUrl: 'fast/submodules/schoolside/applications/mainContent/tabs/awardCalculation/rightAwardCalculation/reportedIncome/reportedIncome.html?v=' + versionNo,
    controller: 'ReportedIncomeController'
});
